import { useState, useEffect } from "react";

export const useIsLoadingVisibile = (
  isLoading: boolean,
  extraInterval?: number,
  debounce?: number
) => {
  const [isLoadingVisible, setIsLoadingVisible] = useState(false);

  useEffect(() => {
    let timeout: NodeJS.Timeout;

    if (isLoading && !isLoadingVisible) {
      if (debounce === 0) {
        setIsLoadingVisible(true);
      } else {
        timeout = setTimeout(
          () => {
            setIsLoadingVisible(true);
          },
          debounce === undefined ? 150 : debounce
        );
      }
    } else if (!isLoading && isLoadingVisible) {
      timeout = setTimeout(
        () => {
          setIsLoadingVisible(false);
        },
        300 + (extraInterval || 0)
      );
    }

    return () => {
      clearTimeout(timeout);
    };
  }, [isLoading, isLoadingVisible, extraInterval, debounce]);

  return isLoadingVisible;
};
